import { AppSelectors } from 'src/app/store/app/app.selectors';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output
} from '@angular/core';
import { MealTime, PopularItem, SharedPosLocation } from '../../../models';
import { ViewSelectSnapshot } from '@ngxs-labs/select-snapshot';
import { PosManagerSelectors } from '../../../store/pos-manager';
import { faCircle } from '@fortawesome/pro-solid-svg-icons';

@Component({
  selector: 'pos-most-popular-items',
  templateUrl: './most-popular-items.component.html',
  styleUrls: ['./most-popular-items.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MostPopularItemsComponent implements OnInit {
  @ViewSelectSnapshot(AppSelectors.getSelectedLocaleCode)
  currentLang: string;

  @Input() mostPopularItems: PopularItem[] = [];
  @Input() selectedMealId: MealTime = MealTime.Breakfast;
  @Input() onMealChange: (mealId: MealTime) => void = () => {};
  @Input() date = '';
  @Input() posLocationId: number = null;
  @Output() mealChange = new EventEmitter<MealTime>();
  @Output() backClicked = new EventEmitter<void>();
  @ViewSelectSnapshot(PosManagerSelectors.getPosLocations)
  readonly locations: SharedPosLocation[];
  currentLocation: SharedPosLocation;

  readonly MealTime = MealTime;

  ngOnInit() {
    this.currentLocation =
      this.locations?.find((location) => location.id === this.posLocationId) ||
      null;
  }

  onMealChangeHandler(mealId: MealTime) {
    this.selectedMealId = mealId;
    this.mealChange.emit(mealId);
    if (this.onMealChange) {
      this.onMealChange(mealId);
    }
  }

  onBack() {
    this.backClicked.emit();
  }

  readonly faCircle = faCircle;
}
